import type { DocumentTypePayload } from '@Application/Documents/DocumentTypes/Actions/documentTypesFetched';

// Same wire shape as a fetched row: the create endpoint returns the freshly created type in full.
export type DocumentTypeCreatedPayload = DocumentTypePayload;

export type DocumentTypeCreatedAction = {
	type: 'DOCUMENT_TYPE_CREATED';
	payload: DocumentTypeCreatedPayload;
	accountId: number;
};

export default (payload: DocumentTypeCreatedPayload, accountId: number): DocumentTypeCreatedAction => ({
	type: 'DOCUMENT_TYPE_CREATED',
	payload,
	accountId,
});
